{
  "name": "vira-vehicle-info-web",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --configuration local",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "eslint . --ext .ts,.html",
    "lint:fix": "eslint . --ext .ts,.html --fix",
    "format": "prettier --write \"src/**/*.{ts,html,scss,css,json}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,css,json}\"",
    "prepare": "husky install"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.0",
    "@angular/compiler": "^19.2.0",
    "@angular/core": "^19.2.0",
    "@angular/forms": "^19.2.0",
    "@angular/platform-browser": "^19.2.0",
    "@angular/platform-browser-dynamic": "^19.2.0",
    "@angular/router": "^19.2.0",
    "@ngrx/signals": "^19.2.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeng/themes": "^20.3.0",
    "@primeuix/themes": "^1.2.5",
    "chart.js": "^4.5.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primelocale": "^2.2.2",
    "primeng": "^19.1.4",
    "rxjs": "~7.8.0",
    "sass": "^1.93.3",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.3",
    "@angular-eslint/builder": "21.0.1",
    "@angular-eslint/eslint-plugin": "21.0.1",
    "@angular-eslint/eslint-plugin-template": "21.0.1",
    "@angular-eslint/schematics": "21.0.1",
    "@angular-eslint/template-parser": "21.0.1",
    "@angular/cli": "^19.2.3",
    "@angular/compiler-cli": "^19.2.0",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "8.48.1",
    "@typescript-eslint/parser": "8.48.1",
    "angular-eslint": "21.0.1",
    "autoprefixer": "^10.4.21",
    "eslint": "8.57.1",
    "husky": "^9.1.7",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.5.2",
    "postcss": "^8.5.6",
    "prettier": "^3.8.1",
    "tailwindcss": "^4.1.17",
    "typescript": "~5.7.2",
    "typescript-eslint": "^8.48.1"
  }
}
